(function ($, window) {
    $.layoutManagerHandlers.registerCardHandler({
        "fr.kosmos.psk.layout.card.bean.AccrocheCardBean": {
            check: function (card) {
                if (card) {
                    return $.layoutManager.states.checked;
                }
                return $.layoutManager.states.incomplete;
            }
        }
    });
})(jQuery.noConflict(),window);
